(function (root) {
  'use strict';
  const formatMoney = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD',minimumFractionDigits:cents % 100 ? 2 : 0,maximumFractionDigits:2}).format(cents / 100);
  function parts(date, timezone) {
    const values = Object.fromEntries(new Intl.DateTimeFormat('en-US', {timeZone:timezone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(date).filter(x => x.type !== 'literal').map(x => [x.type, Number(x.value)]));
    return values;
  }
  const dayStamp = p => Date.UTC(p.year,p.month-1,p.day);
  const dateKey = p => `${p.year}-${String(p.month).padStart(2,'0')}-${String(p.day).padStart(2,'0')}`;
  function wallTimeToUtc(p, hour, timezone) {
    const target = Date.UTC(p.year,p.month-1,p.day,hour);
    let instant = target;
    for (let i = 0; i < 4; i++) {
      const local = parts(new Date(instant),timezone);
      const represented = Date.UTC(local.year,local.month-1,local.day,local.hour,local.minute,local.second);
      const delta = target-represented;
      instant += delta;
      if (!delta) break;
    }
    return instant;
  }
  function dispatchStatus(now, config, available = true) {
    if (!config?.dispatch_enabled || !available) return null;
    const time = new Date(now);
    if (!Number.isFinite(time.getTime())) return null;
    try {
      const local = parts(time, config.dispatch_timezone);
      const days = new Set(config.dispatch_days.map(Number));
      const closed = new Set(config.dispatch_closed_dates || []);
      for (let offset=0; offset<370; offset++) {
        const day = new Date(dayStamp(local)+offset*86400000);
        const p={year:day.getUTCFullYear(),month:day.getUTCMonth()+1,day:day.getUTCDate()};
        if (!days.has(day.getUTCDay()) || closed.has(dateKey(p))) continue;
        const cutoff = wallTimeToUtc(p, Number(config.dispatch_hour), config.dispatch_timezone);
        if (cutoff <= time.getTime()) continue;
        return {kind:offset===0?'today':'next',seconds:Math.ceil((cutoff-time.getTime())/1000),date:dateKey(p),dayLabel:offset===1?'tomorrow':new Intl.DateTimeFormat('en-US',{weekday:'long',timeZone:'UTC'}).format(day)};
      }
    } catch {}
    return null;
  }
  function shippingStatus(subtotalCents, thresholdCents, itemCount) {
    const total = Math.max(0,Math.round(Number(subtotalCents)||0));
    const threshold = Math.max(1,Math.round(Number(thresholdCents)||1));
    const unlocked = itemCount>0 && total>=threshold;
    return {remaining:Math.max(0,threshold-total),progress:Math.min(100,total/threshold*100),unlocked,
      message:unlocked?'Complimentary US shipping unlocked.':itemCount>0?`You’re ${formatMoney(threshold-total)} away from complimentary US shipping.`:`Complimentary US shipping on orders ${formatMoney(threshold)}+.`};
  }
  function readConfig() {
    const el = document.getElementById('jj-offer-config');
    try { return JSON.parse(el?.textContent || '{}'); } catch { return {}; }
  }
  function renderDispatch() {
    const config = readConfig();
    document.querySelectorAll('[data-dispatch]').forEach(el => {
      const status=dispatchStatus(new Date(),config,el.dataset.available!=='false');
      el.hidden=!status;
      if (!status) return;
      const label=el.querySelector('[data-dispatch-label]');
      const timer=el.querySelector('[data-dispatch-clock]');
      const ending=el.querySelector('[data-dispatch-ending]');
      if (status.kind==='today') {
        const h=Math.floor(status.seconds/3600),m=Math.floor(status.seconds%3600/60),s=status.seconds%60;
        label.textContent='Order in';
        timer.textContent=`${String(h).padStart(2,'0')}h ${String(m).padStart(2,'0')}m ${String(s).padStart(2,'0')}s`;
        timer.hidden=false;
        ending.textContent='for dispatch today.';
      } else {
        label.textContent=`Orders placed now dispatch ${status.dayLabel}.`;
        timer.hidden=true;
        ending.textContent='';
      }
    });
  }
  function renderShipping(subtotalCents, itemCount) {
    const config=readConfig();
    document.querySelectorAll('[data-shipping-progress]').forEach(el => {
      const native=el.dataset.subtotal!==undefined;
      if (!native && subtotalCents === undefined) return;
      const enabled=config.shipping_enabled && (el.dataset.eligible!=='false');
      el.hidden=!enabled;
      if (!enabled) return;
      const total=native?Number(el.dataset.subtotal):subtotalCents;
      const count=native?Number(el.dataset.itemCount):itemCount;
      const status=shippingStatus(total,config.shipping_threshold_cents,count);
      el.querySelector('[data-shipping-label]').textContent=status.message;
      const bar=el.querySelector('progress');bar.value=status.progress;
      const hint=el.querySelector('[data-shipping-hint]');
      hint.textContent=status.unlocked?'US delivery in 3–5 days.':`${formatMoney(config.shipping_fee_cents)} below ${formatMoney(config.shipping_threshold_cents)}. Based on your subtotal after discounts.`;
    });
  }
  const api={dispatchStatus,shippingStatus,formatMoney,renderShipping};
  if (typeof module!=='undefined' && module.exports) module.exports=api;
  root.JuneJongOffers=api;
  if (typeof document!=='undefined') {
    const init=()=>{renderDispatch();renderShipping();setInterval(renderDispatch,1000);document.addEventListener('visibilitychange',renderDispatch);};
    if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  }
})(typeof window!=='undefined'?window:globalThis);
